type AddressByZipCode = {
  zipCode: string;
  street: string;
  neighbourhood: string;
  city: string;
  state: string;
};

type Coordinates = {
  latitude: number;
  longitude: number;
};

type GeocodingInput = {
  zipCode?: string;
  street?: string;
  city?: string;
  state?: string;
};

export function getAddressByZipCode(cep: string): Promise<AddressByZipCode | undefined> {
  const zipCode = cep.replace(/\D/g, '');
  if (!zipCode?.length || zipCode.length !== 8) return Promise.resolve(undefined);

  return fetch(`https://viacep.com.br/ws/${zipCode}/json/`)
    .then((res) => res.json())
    .then((data) => ({
      zipCode,
      street: data.logradouro,
      neighbourhood: data.bairro,
      city: data.localidade,
      state: data.uf,
    }));
}

export async function getCoordinatesByAddress(input: GeocodingInput): Promise<Coordinates | null> {
  const zipCode = input.zipCode?.replace(/\D/g, "") || "";

  const queryParts = [input.street, input.city, input.state, zipCode, "Brasil"]
    .filter(Boolean)
    .map((part) => String(part).trim())
    .filter(Boolean);

  if (!queryParts.length) return null;

  try {
    const params = new URLSearchParams({
      format: "json",
      limit: "1",
      "accept-language": "pt-BR",
      countrycodes: "br",
      q: queryParts.join(", "),
    });

    const response = await fetch(`https://nominatim.openstreetmap.org/search?${params.toString()}`);
    const data = await response.json();

    if (!Array.isArray(data) || data.length === 0) {
      return null;
    }

    const latitude = Number(data[0].lat);
    const longitude = Number(data[0].lon);

    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
      return null;
    }

    return { latitude, longitude };
  } catch {
    return null;
  }
}

export default getAddressByZipCode
